import { HeaderBannersActions, HeaderBannersActionType } from '@/store/cms/header-banners/actions';
import { BffCmsHeaderBannersResponse } from '@lucky7ventures/bff-types';

export interface HeaderBannersState {
  headerBanners: BffCmsHeaderBannersResponse;
  loading: boolean;
  error: boolean;
}

const initialState: HeaderBannersState = {
  headerBanners: [],
  loading: false,
  error: false,
};

export const headerBannersReducer = (
  state = initialState,
  action: HeaderBannersActions,
): HeaderBannersState => {
  switch (action.type) {
    case HeaderBannersActionType.GetHeaderBanners:
      return { ...state, loading: true, error: false };
    case HeaderBannersActionType.GetHeaderBannersError:
      return { ...state, loading: false, error: true };
    case HeaderBannersActionType.GetHeaderBannersSuccess: {
      return {
        ...state,
        headerBanners: action.headerBanners,
        loading: false,
        error: false,
      };
    }
    default:
      return state;
  }
};
